import { render, staticRenderFns } from "./ReferralSidebar.vue?vue&type=template&id=09613972"
import script from "./ReferralSidebar.vue?vue&type=script&lang=js"
export * from "./ReferralSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports